/*
--- 
description: FED Process
authors: 
- David Chan CK
- Anton Burov
license:
- MIT-style license
requires: 
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [BasicMaps]
...
*/
var BasicMapsLux = new Class({
	Extends: BasicMaps,
	
	process_rpc: function() {
		this.parent();
		var data = this.main_remote.get_data();
		
		this.map.setOptions( Object.merge({
														mapTypeControl: true,
														navigationControl: true,
														streetViewControl: true,
														panControl: true,
														zoomControlOptions: { style: google.maps.ZoomControlStyle.LARGE }
												 })
											 );
											 
		if (data.categories) {
			data.categories[0].places.each(function(place, i) {						
						var mark = this.create_marker(place, data);
						 
						this.markers.push(mark);
						var content = this.create_bubble_content(place);

						var b = this.create_bubble(mark, content);
						google.maps.event.addListener(mark.get_object(), 'click', function(){ 
																																				this.open_bubble(b, mark);
																																			}.bind(this));						
			}.bind(this));
		}	 
		
		this.bound_overlays();
	},
	
	create_marker: function(place, data){
		return new GoogleMaps.Marker(this, {
																				lat: place.lat,
																				lng: place.lng																				
																				});
	},
	
	open_bubble: function(b, mark){
		if(this.current_bubble){
			this.current_bubble.close();
		}
		this.current_bubble = b;
		b.open(this, mark);
	},
	
	create_bubble_content: function(place){
		var bubble;
		
		bubble	= '<div class="w_googlemaps_overlay_pointer"></div>';
		bubble += '<div class="w_googlemaps_overlay_content">';
		bubble +=	 '<div class="w_googlemaps_overlay_info">';
		bubble +=		 '<div class="address">' + place.location + '</div>';
		bubble +=		 '<div class="stat">';
		bubble +=			 '<ul>';
		bubble +=				 '<li>' + place.interested + ' buyers interested in building</li>';
		bubble +=				 '<li>' + place.appointments + ' appointments scheduled</li>';
		bubble +=			 '</ul>';		
		bubble +=		 '</div>';
		bubble +=	 '</div>';
		bubble +=	 '<img src="' + place.photo + '" class="w_googlemaps_overlay_photo"/>';
		bubble += '</div>';
		
		return bubble;
	},
	
	create_bubble: function(mark, content){
		return new GoogleMaps.BubbleExt(this, mark, { content: content });
	}
		
});



